export function clampIsoDate(value: string, min?: string, max?: string): string {
  if (!value) {
    return ''
  }

  if (min && value < min) {
    return min
  }

  if (max && value > max) {
    return max
  }

  return value
}
